// extracted by mini-css-extract-plugin
export default {"container":"MainPage_container__33wji","videoWrap":"MainPage_videoWrap__EzITT"};